import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

// Create a Context for the login modal
export const LoginModalContext = createContext();

export const LoginModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const callback = useRef(null);
  const [QR, setQR] = useState(true); 
  
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
    callback.current = null;
    setQR(true);
  }, []);

  return (
    <LoginModalContext.Provider value={{ isOpen, onOpen, onClose, QR, setQR, callback }}>
      {children}
    </LoginModalContext.Provider>
  );
};
